<crm-single-select
  [options]="arraySms"
  [(selectedItem)]="selectedSms"
  (selectedItemChange)="selectSms($event)"
  class="w-full {{ isError ? 'ng-invalid ng-dirty' : '' }}"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [showClear]="showClear"
  [isTemplateCombined]="true"
  [filter]="false"
  [appendTo]="appendTo"
  optionLabel="sender">
  <ng-template
    #itemTemplate
    let-sms="item">
    <ng-container *ngIf="toSms(sms) as sms">
      <p class="font-medium">Отправитель: {{ sms.sender }}</p>
      <p
        *ngIf="sms.project"
        class="text-green-600">
        Проект: {{ sms.project }}
      </p>
    </ng-container>
  </ng-template>
</crm-single-select>
